export const fetchContentDetails = async (id) => {
    if (!id) {
        console.log('process terminate.');
        return
    }
    try {
        const response = await fetch(
            `${process.env.REACT_APP_API_URL}/api-provider/v1/contentDetail/${id}`,
            {
                method: "GET",
                headers: {
                    Accept: "application/json",
                },
            }
        );
        const data = await response.json();
        return data
    } catch (error) {
        console.error("Error fetching details:", error);
        return error
    }
};